import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  Row,
  Col
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  savePaymentSetting,
  getPaymentSetting
} from "../../../redux/actions/payemntSettingAction";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

const history = createHashHistory();

class PaymentSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'PAYMENT_SETTING',
      path: ["Home", "Payment Setting"],
      links: ["home",'payment-setting'],
      guestCheckout: "enable",
      referall: "enable",
      referralAmount: "",
      environment: "sandbox",
      authorizeSandBoxLoginID: "",
      authorizeSandBoxTransactionKey: "",
      authorizeSandBoxSecretKey: "",
      authorizeLiveLoginID: "",
      authorizeLiveTransactionKey: "",
      authorizeLiveSecretKey: "",
      paypalSandBoxUsername: "",
      paypalSandBoxPassword: "",
      paypalSandBoxSignature: "",
      paypalLiveUsername: "",
      paypalLivePassword: "",
      paypalLiveSignature: "",
      alertMessage: "",
      show: false,
      disabled: false,
      submitValue: "Save",
      referralAmountError: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleChange = e => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }

    this.setState({ [e.target.name]: e.target.value });
  };

  validate = () => {
    let isError = false;
    const errors = {};

    if (this.state.referall == "enable") {
      if (this.state.referralAmount === "") {
        isError = true;
        this.setState({ referralAmountError: "red" });
      }
    }

    if (this.state.referall == "enable") {
      if (!this.state.referralAmount) {
        isError = true;
        this.setState({ referralAmountError: "red" });
      }
    }
    return isError;
  };

  handleSubmit = e => {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      this.setState({ submitValue: "Saving..", disabled: true });
      const formData = new FormData();
      formData.append("settings['guestCheckout']", this.state.guestCheckout);
      formData.append("settings['referall']", this.state.referall);
      formData.append("settings['referralAmount']", this.state.referralAmount);
      formData.append("settings['environment']", this.state.environment);
      formData.append(
        "settings['authorizeSandBoxLoginID']",
        (this.state.authorizeSandBoxLoginID) ? this.state.authorizeSandBoxLoginID : ""
      );
      formData.append(
        "settings['authorizeSandBoxTransactionKey']",
        (this.state.authorizeSandBoxTransactionKey) ? this.state.authorizeSandBoxTransactionKey : ""
      );
      formData.append(
        "settings['authorizeSandBoxSecretKey']",
        (this.state.authorizeSandBoxSecretKey) ? this.state.authorizeSandBoxSecretKey : ""
      );
      formData.append(
        "settings['authorizeLiveLoginID']",
        (this.state.authorizeLiveLoginID) ? this.state.authorizeLiveLoginID : ""
      );
      formData.append(
        "settings['authorizeLiveTransactionKey']",
        (this.state.authorizeLiveTransactionKey) ? this.state.authorizeLiveTransactionKey : ""
      );
      formData.append(
        "settings['authorizeLiveSecretKey']",
        (this.state.authorizeLiveSecretKey) ? this.state.authorizeLiveSecretKey : ""
      );
      formData.append(
        "settings['paypalSandBoxUsername']",
        (this.state.paypalSandBoxUsername) ? this.state.paypalSandBoxUsername : ""
      );
      formData.append(
        "settings['paypalSandBoxPassword']",
        (this.state.paypalSandBoxPassword) ? this.state.paypalSandBoxPassword : ""
      );
      formData.append(
        "settings['paypalSandBoxSignature']",
        (this.state.paypalSandBoxSignature) ? this.state.paypalSandBoxSignature : ""
      );
      formData.append(
        "settings['paypalLiveUsername']",
        (this.state.paypalLiveUsername) ? this.state.paypalLiveUsername : "" 
      );
      formData.append(
        "settings['paypalLivePassword']",
        (this.state.paypalLivePassword) ? this.state.paypalLivePassword : ""
      );
      formData.append(
        "settings['paypalLiveSignature']",
        (this.state.paypalLiveSignature) ? this.state.paypalLiveSignature : ""
      );

      this.props.savePaymentSetting(formData);
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentDidMount() {}

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getPaymentSetting();
  }


  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }

    if (this.props.settingStatus !== nextProps.settingStatus) {
      if (nextProps.settingStatus) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.settingStatus.message);
        this.setState({ submitValue: "Save", disabled: false });
        window.scrollTo(0, 0);
      }

    }

    if (this.props.paymentSetting !== nextProps.paymentSetting) {
      if (nextProps.paymentSetting) {
        let data = nextProps.paymentSetting.data;
        this.setState({
          guestCheckout: data.guestCheckout,
          referall: data.referall,
          referralAmount: data.referralAmount,
          environment: (data.environment) ? data.environment : 'sandbox',
          authorizeSandBoxLoginID: data.authorizeSandBoxLoginID,
          authorizeSandBoxTransactionKey: data.authorizeSandBoxTransactionKey,
          authorizeSandBoxSecretKey: data.authorizeSandBoxSecretKey,
          authorizeLiveLoginID: data.authorizeLiveLoginID,
          authorizeLiveTransactionKey: data.authorizeLiveTransactionKey,
          authorizeLiveSecretKey: data.authorizeLiveSecretKey,
          paypalSandBoxUsername: data.paypalSandBoxUsername,
          paypalSandBoxPassword: data.paypalSandBoxPassword,
          paypalSandBoxSignature: data.paypalSandBoxSignature,
          paypalLiveUsername: data.paypalLiveUsername,
          paypalLivePassword: data.paypalLivePassword,
          paypalLiveSignature: data.paypalLiveSignature
        });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ submitValue: "Save", disabled: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }
    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
            </div>
          </div>
          <form onSubmit={this.handleSubmit}>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <Row>
              {/*Referall System Start*/}
              <Col md={4} xs={12}>
                <div className="panel">
                  <header className="panel-heading">
                    Guest Checkout Switch
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Guest Checkout</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.guestCheckoutError }}
                          name="guestCheckout"
                          onChange={this.handleChange}
                          value={this.state.guestCheckout}
                        >
                          <option value="enable">Enable</option>
                          <option value="disable">Disable</option>
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="clearfix" />
                </div>
              </Col>
              {/*Referall System End*/}

              {/*Referall System Start*/}
              <Col md={4} xs={12}>
                <div className="panel">
                  <header className="panel-heading">
                    Referral System Switch
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Referral System</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.referallError }}
                          name="referall"
                          onChange={this.handleChange}
                          value={this.state.referall}
                        >
                          <option value="enable">Enable</option>
                          <option value="disable">Disable</option>
                        </FormControl>
                        {this.state.referall == "enable" ? (
                          <div>
                            <ControlLabel>Referral Amount</ControlLabel>
                            <FormControl
                              type="number"
                              placeholder="Referral Amount"
                              name="referralAmount"
                              onChange={this.handleChange}
                              value={this.state.referralAmount}
                              style={{
                                borderColor: this.state.referralAmountError
                              }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="clearfix" />
                </div>
              </Col>
              {/*Referall System End*/}

              {/*Payment API Environment Setting Start*/}
              <Col md={4} xs={12}>
                <div className="panel">
                  <header className="panel-heading">
                    Payment API Environment
                  </header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>Environment</ControlLabel>
                        <FormControl
                          componentClass="select"
                          style={{ borderColor: this.state.environmentError }}
                          name="environment"
                          onChange={this.handleChange}
                          value={this.state.environment}
                        >
                          <option value="sandbox">Sandbox</option>
                          <option value="live">Live</option>
                        </FormControl>
                      </Col>
                    </Row>
                  </div>
                  <div className="clearfix" />
                </div>
              </Col>
              {/*Payment API Environment Setting End*/}
            </Row>
            {/*Authorize.net Setting Start*/}
            <div className="panel">
              <header className="panel-heading">Authorize.Net</header>
              <div className="panel-body">
                <Row>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Sandbox Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>API Login ID</ControlLabel>
                        <FormGroup controlId="authorizeSandBoxLoginID">
                          <FormControl
                            type="text"
                            value={this.state.authorizeSandBoxLoginID}
                            placeholder="API Login ID"
                            onChange={this.handleChange}
                            name="authorizeSandBoxLoginID"
                            style={{
                              borderColor: this.state
                                .authorizeSandBoxLoginIDError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Transaction Key</ControlLabel>
                        <FormGroup controlId="authorizeSandTransactionKey">
                          <FormControl
                            type="text"
                            value={this.state.authorizeSandBoxTransactionKey}
                            placeholder="Transaction Key"
                            onChange={this.handleChange}
                            name="authorizeSandBoxTransactionKey"
                            style={{
                              borderColor: this.state
                                .authorizeSandBoxTransactionKeyError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Secret Key</ControlLabel>
                        <FormGroup controlId="authorizeSSecretKey">
                          <FormControl
                            type="text"
                            value={this.state.authorizeSandBoxSecretKey}
                            placeholder="Secret Key"
                            onChange={this.handleChange}
                            name="authorizeSandBoxSecretKey"
                            style={{
                              borderColor: this.state
                                .authorizeSandBoxSecretKeyError
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Live Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>API Login ID</ControlLabel>
                        <FormGroup controlId="authorizeLLoginID">
                          <FormControl
                            type="text"
                            value={this.state.authorizeLiveLoginID}
                            placeholder="API Login ID"
                            onChange={this.handleChange}
                            name="authorizeLiveLoginID"
                            style={{
                              borderColor: this.state.authorizeLiveLoginIDError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Transaction Key</ControlLabel>
                        <FormGroup controlId="authorizeLTransactionKey">
                          <FormControl
                            type="text"
                            value={this.state.authorizeLiveTransactionKey}
                            placeholder="Transaction Key"
                            onChange={this.handleChange}
                            name="authorizeLiveTransactionKey"
                            style={{
                              borderColor: this.state
                                .authorizeLiveTransactionKeyError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Secret Key</ControlLabel>
                        <FormGroup controlId="authorizeLSecretKey">
                          <FormControl
                            type="text"
                            value={this.state.authorizeLiveSecretKey}
                            placeholder="Secret Key"
                            onChange={this.handleChange}
                            name="authorizeLiveSecretKey"
                            style={{
                              borderColor: this.state
                                .authorizeLiveSecretKeyError
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="clearfix" />
            </div>
            {/*Authorize.net Setting End*/}

            {/*Authorize.net Setting Start*/}
            <div className="panel">
              <header className="panel-heading">Paypal</header>
              <div className="panel-body">
                <Row>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Sandbox Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Username</ControlLabel>
                        <FormGroup controlId="paypalSandUsername">
                          <FormControl
                            type="text"
                            value={this.state.paypalSandBoxUsername}
                            placeholder="User Name"
                            onChange={this.handleChange}
                            name="paypalSandBoxUsername"
                            style={{
                              borderColor: this.state.paypalSandBoxUsernameError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Password</ControlLabel>
                        <FormGroup controlId="paypalSandPassword">
                          <FormControl
                            type="text"
                            value={this.state.paypalSandBoxPassword}
                            placeholder="Password"
                            onChange={this.handleChange}
                            name="paypalSandBoxPassword"
                            style={{
                              borderColor: this.state.paypalSandBoxPasswordError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Signature</ControlLabel>
                        <FormGroup controlId="paypalSandBoxSignature">
                          <FormControl
                            type="text"
                            value={this.state.paypalSandBoxSignature}
                            placeholder="Signature"
                            onChange={this.handleChange}
                            name="paypalSandBoxSignature"
                            style={{
                              borderColor: this.state
                                .paypalSandBoxSignatureError
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6} xs={12}>
                    <Row>
                      <Col md={12} xs={12}>
                        <ControlLabel>
                          <h4>Live Environment</h4>
                        </ControlLabel>
                        <hr />
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Username</ControlLabel>
                        <FormGroup controlId="paypalLiveUsername">
                          <FormControl
                            type="text"
                            value={this.state.paypalLiveUsername}
                            placeholder="User Name"
                            onChange={this.handleChange}
                            name="paypalLiveUsername"
                            style={{
                              borderColor: this.state.paypalLiveUsernameError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Password</ControlLabel>
                        <FormGroup controlId="paypalLivePassword">
                          <FormControl
                            type="text"
                            value={this.state.paypalLivePassword}
                            placeholder="Password"
                            onChange={this.handleChange}
                            name="paypalLivePassword"
                            style={{
                              borderColor: this.state.paypalLivePasswordError
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={12} xs={12}>
                        <ControlLabel>Signature</ControlLabel>
                        <FormGroup controlId="paypalLiveSignature">
                          <FormControl
                            type="text"
                            value={this.state.paypalLiveSignature}
                            placeholder="Signature"
                            onChange={this.handleChange}
                            name="paypalLiveSignature"
                            style={{
                              borderColor: this.state.paypalLiveSignatureError
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="clearfix" />
            </div>
            {/*Authorize.net Setting End*/}
            <Row className="BtnRow">
              <Col md={12} xs={12}>
                <Button
                  bsStyle="info"
                  type="submit"
                  id="saveButton"
                  disabled={this.state.disabled}
                >
                  {this.state.submitValue}
                </Button>
                <Button
                  bsStyle="default"
                  onClick={() => history.push(`/dashboard`)}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    );
  }
}

PaymentSetting.propTypes = {
  savePaymentSetting: PropTypes.func.isRequired,
  getPaymentSetting: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  settingStatus: state.paymentSettingReducer.settingStatus,
  paymentSetting: state.paymentSettingReducer.paymentSetting,
  error: state.paymentSettingReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default withRouter(connect(mapStateToProps, {
  savePaymentSetting,
  getPaymentSetting,
  renderAlert,
  clearAlert
})(PaymentSetting));



// WEBPACK FOOTER //
// ./src/app/views/admin/paymentSetting/PaymentSetting.js